import React from 'react';
import { Chip } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { launchColors } from '../launchTheme';

export type CategoryChipVariant = 'published' | 'available' | 'new' | 'selectable';

interface Props {
  label: string;
  variant: CategoryChipVariant;
  selected?: boolean;
  onToggle?: () => void;
}

const CategoryChip: React.FC<Props> = ({ label, variant, selected = false, onToggle }) => {
  const filled = variant === 'published' || (variant === 'selectable' && selected);
  const text = variant === 'new' ? `${label} · Ny` : label;
  return (
    <Chip
      size="small"
      label={text}
      variant={filled ? 'filled' : 'outlined'}
      icon={variant === 'selectable' && selected ? <CheckIcon /> : undefined}
      onClick={variant === 'selectable' ? onToggle : undefined}
      aria-pressed={variant === 'selectable' ? selected : undefined}
      sx={{
        height: 26,
        maxWidth: '100%',
        fontWeight: 600,
        borderStyle: variant === 'new' ? 'dashed' : 'solid',
        ...(variant === 'published' && { bgcolor: launchColors.mossLight, color: launchColors.mossDark, borderColor: launchColors.moss }),
        ...(variant === 'available' && { bgcolor: launchColors.card, color: launchColors.text, borderColor: launchColors.divider }),
        ...(variant === 'new' && { bgcolor: launchColors.card, color: launchColors.navy, borderColor: launchColors.navy }),
        ...(variant === 'selectable' && selected && {
          bgcolor: launchColors.navy,
          color: '#FFFFFF',
          '& .MuiChip-icon': { color: '#FFFFFF' },
        }),
        ...(variant === 'selectable' && !selected && { bgcolor: launchColors.card, color: launchColors.navy, borderColor: launchColors.divider }),
      }}
    />
  );
};

export default CategoryChip;
